module.exports = __webpack_public_path__ + "img/广州仓库 (2).a21a1109.jpg";